
import { IonHeader, IonToolbar, IonTitle, IonBackButton, IonButtons } from '@ionic/vue';
import { defineComponent } from "vue";

export default defineComponent({
  name: "PageHeader",
  props: ['title'],
  components: {IonHeader, IonToolbar, IonTitle, IonBackButton, IonButtons}
})
